import { useState, useContext, useEffect } from "react";
import landscape from "../images/landscape.svg";
import portaite from "../images/portaite.svg";
import { DataContext } from "./DataProvider";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import Logo from "./smallComponents/Logo";

const Header = () => {
    const { viewPosition, setViewPosition, setWidth1, setWidth2, setWidth3, setHeight1, setHeight2, setToggle1, html, css, js } = useContext(DataContext)
    const location = useLocation();
    const [changesArray, setChangesArray] = useState([]);
    const newChangesArray = [{ html, css, js }];
    const { penId } = useParams();
    const [documentName, setDocumentName] = useState("new document");


    function chagesSave() {
        return JSON.stringify(changesArray) === JSON.stringify(newChangesArray)
    }

    const headerStyle = {
        width: "calc(100% - 30px)",
        height: "60px",
        padding: "0 15px",
        background: "#0c0f1a",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",

        name_change_div: {
            display: "flex",
            flexDirection: "row",
            placeItems: "center",

            document_name: {
                color: "white",
                padding: "3px 10px",
                fontSize: "18px",
                textAlign: "center",
                background: "transparent",
                // border: "none",
                // outline: "none",
                width: "max-content"
            },
        },

        rightDiv: {
            width: "max-content",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "15px",

            saveButton: {
                padding: "5px 15px",
                fontSize: "20px",
                borderRadius: "7px",
                background: chagesSave() ? "#ffffff50" : "#ffffff",
                color: "black",
            },

            UserButton: {
                padding: "10px 20px",
                fontSize: "20px",
                borderRadius: "7px",
                background: "var(--buttonColor)",
                color: "white",
            },

            imageDiv: {
                width: "30px",
                height: "30px",
                cursor: "pointer",

                divImage: {
                    width: "100%",
                }
            },
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!location.pathname.includes("/magicpen")) return;
        window.addEventListener('beforeunload', function (e) {
            e.preventDefault();
        });
        if (changesArray.length === 0) {
            setChangesArray([{ html, css, js }])
        }
    });


    const handleKeypress = (e) => {

    }

    const handleClick = () => {
        setViewPosition(!viewPosition);
        setWidth1(0);
        setWidth2(0);
        setWidth3(0);
        setHeight1(0);
        setHeight2(0);
        setToggle1(null);
        setToggle1(null);
        setToggle1(null);
    }

    const handleSaveClick = () => {
        setChangesArray(newChangesArray);
    }


    const handleDocumentNameChange = (e) => {
        let value = e.target.value;
        setDocumentName(value)
    }

    return (
        <>
            <div style={headerStyle} id="navbar">
                <Logo />
                {location.pathname.includes("/magicpen") &&
                    <div style={headerStyle.name_change_div}>
                        <div style={headerStyle.name_change_div.document_name}
                            contentEditable="true"
                            id="document_name"
                            value={`${documentName}-${penId}`}
                            suppressContentEditableWarning="true"
                            onChange={handleDocumentNameChange}
                            onKeyDown={handleKeypress}
                        // onClick={() => this.contentEditable = true }
                        >{documentName}-{penId}</div>
                    </div>
                }
                <div style={headerStyle.rightDiv}>
                    {location.pathname.includes("/magicpen") &&
                        <>
                            <button style={headerStyle.rightDiv.saveButton} onClick={handleSaveClick} >Save</button>
                            <div style={headerStyle.rightDiv.imageDiv} onClick={handleClick}>
                                <img style={headerStyle.rightDiv.imageDiv.divImage} src={viewPosition ? landscape : portaite} alt={"change position"} />
                            </div>
                        </>
                    }
                    <Link to={"/sign-up"}>
                        <button style={headerStyle.rightDiv.UserButton}>Sign Up</button>
                    </Link>
                    <Link to={"/login"}>
                        <button style={headerStyle.rightDiv.UserButton}>Login</button>
                    </Link>
                </div>
            </div>
            <Outlet />
        </>
    );
}

export default Header;